const truncate = (str, maxLength, ellipsis = "...") => {
  if (typeof str !== "string") {
    return "";
  }
  if (!str) {
    return "";
  }
  if (str.length <= maxLength) {
    return str;
  }
  const truncateLength = Math.max(0, maxLength - ellipsis.length);
  if (truncateLength <= 0) {
    return ellipsis;
  }
  return str.slice(0, truncateLength) + ellipsis;
};
export {
  truncate
};
//# sourceMappingURL=truncate.js.map
